module.exports = __webpack_public_path__ + "static/img/level2.59287504.png";